module.exports = __webpack_public_path__ + "img/qg_thumb.5269dd43.png";